export default __webpack_public_path__ + "static/media/face_white_24dp.89701ef4.svg";